import { format } from "date-fns";
import { Body } from "@songtradr-one/components-frontend";
import { Flex } from "../../flex/Flex.Parts";
import { Props, text } from "./DateColumn.Parts";

export const DateColumn = ({ date, defaultText, className }: Props) => (
  <Flex className={className} $direction="column" $gap="0">
    {date ? (
      <>
        <Body variant="normal-strong">
          {format(new Date(date), "MMMM dd, yyyy")}
        </Body>
        <Body variant="small">{format(new Date(date), "h:mm a")}</Body>
      </>
    ) : (
      <Body variant="small">{defaultText || text.notAvailable}</Body>
    )}
  </Flex>
);
